export default __webpack_public_path__ + "static/homepage-31d6740e949bb3ab84a32c8ca2968df48229dc15d264f53f86acbbe952e060d9.png";